import { useQuery } from "@tanstack/react-query";
import { devicesApi } from "@/api/devices";

export function useDevice(deviceId: string) {
  return useQuery({
    queryKey: ["device", deviceId],
    queryFn: () => devicesApi.detail(deviceId),
    refetchInterval: 30_000,
    enabled: !!deviceId,
  });
}
